module.exports = __webpack_public_path__ + "static/media/manualsprayer.9ccede14.jpg";